import './loading.scss';

import React from 'react';


export default function Loading({size = 122, className = ''}) {
  const rootClassName = ['loading-spinner', className].filter(Boolean).join(' ');

  return (
    <svg className={rootClassName} width={size} height={size} viewBox="0 0 122 122" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* left */}
      <circle className="loading-spinner__dot loading-spinner__dot--0" cx="10.1667" cy="61" r="10.1667" />
      {/* top-left */}
      <circle className="loading-spinner__dot loading-spinner__dot--1" cx="25.0553" cy="25.0554" r="10.1667" transform="rotate(135 25.0553 25.0554)" />
      {/* top */}
      <circle className="loading-spinner__dot loading-spinner__dot--2" cx="61" cy="10.1667" r="10.1667" />
      {/* top-right */}
      <circle className="loading-spinner__dot loading-spinner__dot--3" cx="96.9445" cy="25.0553" r="10.1667" transform="rotate(45 96.9445 25.0553)" />
      {/* right */}
      <circle className="loading-spinner__dot loading-spinner__dot--4" cx="111.833" cy="61" r="10.1667" />
      {/* bottom-right */}
      <circle className="loading-spinner__dot loading-spinner__dot--5" cx="96.9444" cy="96.9445" r="10.1667" transform="rotate(135 96.9444 96.9445)" />
      {/* bottom */}
      <circle className="loading-spinner__dot loading-spinner__dot--6" cx="61" cy="111.833" r="10.1667" />
      {/* bottom-left */}
      <circle className="loading-spinner__dot loading-spinner__dot--7" cx="25.0552" cy="96.9446" r="10.1667" transform="rotate(45 25.0552 96.9446)" />
    </svg>
  );
}
